export function formatCount(n) {
  const v = Math.max(0, Math.round(n))
  return v.toLocaleString("en-US")
}

export function formatCurrency(cents) {
  const dollars = Math.max(0, cents) / 100
  return dollars.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  })
}

export function formatPercent(decimal) {
  const v = Math.max(0, decimal) * 100
  return `${v.toFixed(1)}%`
}

export function formatterFor(unit) {
  if (unit === "cents") return formatCurrency
  if (unit === "pct") return formatPercent
  return formatCount
}

export function rawValueFor(counter) {
  if (!counter) return 0
  if (counter.unit === "pct") return parseFloat(counter.value_decimal || 0)
  return Number(counter.value_int || 0)
}
